import { render, staticRenderFns } from "./BranchFilters.vue?vue&type=template&id=2b9dd2e4&"
import script from "./BranchFilters.vue?vue&type=script&lang=js&"
export * from "./BranchFilters.vue?vue&type=script&lang=js&"
import style0 from "./BranchFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BranchFilters.vue"
export default component.exports